<template>
	<div class="card mt-4">
        <div class="card-header">
            <div class="row">
	            <div class="d-flex justify-content-between container-fluid">
			        <div class="text-muted fs-19">
			            <strong>Financeiro</strong>
			        </div>
			        <button 
                        class="btn btn-primary"
                        @click="esconder()">
                        <i class="fas fa-eye"></i>
                    </button>
				</div>
            </div>
        </div>
        <div class="card-body">
            <financeiro-valores
            	v-show="mostrar"
				:date="date">
			</financeiro-valores>
        </div>
    </div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				mostrar: false
			}
		},
		methods: {
			esconder(){
				this.mostrar = !this.mostrar;
			}
		}
	}
</script>